export const isOutOfUpperRange = (position, tooltipWidth, valuePosition, containerWidth) =>
  position + tooltipWidth + valuePosition > containerWidth;
